import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "link-field-container",
        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.handleClick(_ctx.link)))
    }));
}
